/**
 * Default T004 design-token values.
 *
 * These are DATA saved into t004_theme_master.tokens, not CSS, so they cannot
 * be expressed as var(--color-*). They live here rather than in the Themes
 * screen because a token default belongs to the theme layer, and because
 * screens are held to a no-raw-hex rule.
 *
 * t004_tokens_shape_chk rejects any bag missing one of these groups.
 */
export const BASE_NON_COLOUR_TOKENS = {
  typography: { font_family: 'Inter, system-ui, sans-serif', scale: '1.25' },
  spacing: { base_unit: 8 },
  radii: { sm: 4, md: 8, lg: 16, pill: 9999 },
  shadows: {
    sm: '0 1px 3px rgba(0,0,0,.12)',
    md: '0 4px 6px rgba(0,0,0,.12)',
    lg: '0 10px 15px rgba(0,0,0,.12)',
  },
  mode_pair: 'DEFAULT_DARK',
} as const;

/** Readable text on the brand fills, so a saved theme is never unreadable. */
export const DEFAULT_CONTRAST_TOKENS = {
  onPrimary: '#ffffff',
  onSecondary: '#ffffff',
  onSurface: '#0f172a',
  surface: '#ffffff',
} as const;
